// extracted by mini-css-extract-plugin
export default {"root":"dT10FS57BDRMPojWJrtz","items":"h_5VVmwjOAIOq3GDWSAP"};